import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\PropertyLookupController::__invoke
* @see app/Http/Controllers/Api/Internal/PropertyLookupController.php:21
* @route '/internal-api/properties/lookup'
*/
export const show = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/internal-api/properties/lookup',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Internal\PropertyLookupController::__invoke
* @see app/Http/Controllers/Api/Internal/PropertyLookupController.php:21
* @route '/internal-api/properties/lookup'
*/
show.url = (options?: RouteQueryOptions) => {
    return show.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\PropertyLookupController::__invoke
* @see app/Http/Controllers/Api/Internal/PropertyLookupController.php:21
* @route '/internal-api/properties/lookup'
*/
show.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Internal\PropertyLookupController::__invoke
* @see app/Http/Controllers/Api/Internal/PropertyLookupController.php:21
* @route '/internal-api/properties/lookup'
*/
show.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(options),
    method: 'head',
})

const properties = {
    show: Object.assign(show, show),
}

export default properties